import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * Fetch pedidos con filtros opcionales
 * @param {Object} props - Parámetros del hook
 * @param {Object} [props.filtros={}] - Filtros para la búsqueda
 * @returns {Object} { response, error, loading }
 */

const useFetchPedidos = ({
  numero_pedido = '',
  cliente = '',
  articulo = '',
  planificacion_seleccionada = '',
  planta = '',
  palabra = '',
}) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    setError(null)

    // Construir query params
    const params = new URLSearchParams()

    if (numero_pedido) {
      params.append('numero_pedido', numero_pedido)
    }
    if (cliente) {
      params.append('cliente', cliente)
    }
    if (articulo) {
      params.append('articulo', articulo)
    }
    if (planificacion_seleccionada) {
      params.append('planificacion_seleccionada', planificacion_seleccionada)
    }
    if (planta) {
      params.append('planta', planta)
    }
    if (palabra) {
      params.append('palabra', palabra)
    }

    const queryString = params.toString()
    const url = queryString ? `/optprod/adm/pedidos/?${queryString}` : '/optprod/adm/pedidos/'

    axios
      .get(url)
      .then((request_response) => {
        setResponse(request_response.data)
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false))
  }, [numero_pedido, cliente, articulo, planificacion_seleccionada, planta, palabra])

  useEffect(() => {
    // planificacion_seleccionada no cuenta como "filtro de búsqueda"
    // Solo se hace fetch si hay al menos un filtro real
    const hayFiltros = numero_pedido || cliente || articulo || palabra

    if (hayFiltros) {
      fetchData()
    } else {
      setResponse([])
    }
  }, [numero_pedido, cliente, articulo, palabra, planificacion_seleccionada, planta, fetchData])

  return { response, error, loading }
}

export default useFetchPedidos
